@if (cookiesEnabled$ | async) {
  @switch (state) {
    @case ('INTRO') {
      <app-slide-separator
        [type]="data?.type"
        [title]="'QUIZ_SLIDE.TITLE' | translate"
        (buttonClicked)="startQuiz()"
        [buttonText]="'QUIZ_SLIDE.BUTTON.SHOW_QUIZ' | translate"
        [skipLink]="nextLink"
        [backLink]="backLink">
      </app-slide-separator>
    }
    @case ('RESULT') {
      <app-slide-separator
        [type]="data?.type"
        [title]="'QUIZ_SLIDE.TITLE' | translate"
        [introText]="getScoreText(typeformResponse)"
        (buttonClicked)="restartQuiz()"
        [buttonText]="'QUIZ_SLIDE.BUTTON.REDO_QUIZ' | translate"
        [skipLink]="nextLink"
        [backLink]="backLink"
        [skipText]="'SLIDE_NAVBAR.NEXT_SLIDE' | translate">
      </app-slide-separator>
    }
    @case ('QUIZ') {
      <div class="quiz-embed" id="embedTypeform" #embedTypeform></div>
    }
    @case ('LOADING') {
      <div>
        <img class="troodi-spinner" src="assets/img/troodi_spinner.gif" />
      </div>
    }
    @case ('ARTICULATE') {
      <div class="quiz-embed">
        @if (hasArticulateUrl(data)) {
          <iframe [src]="data?.url?.url | trustUrl"></iframe>
        }
      </div>
    }
  }
} @else {
  <div class="cookies-blocked">
    <h2 translate>COOKIE.NOTICE_QUIZ</h2>
  </div>
}
